import React, { FunctionComponent } from 'react'
import LatchelCard from '../Cards/LatchelProperty'
import WorkOrderHistoryCard from '../Cards/WorkOrderHistory'
import ConstructionHistoryCard from '../Cards/ConstructionHistory'
import SystemWorkOrderHistoryCard from '../Cards/SystemWorkOrderHistory'

interface ConstructionPanelProps {
  portfolioHomeId: string
}
export const ConstructionPanel: FunctionComponent<
  React.PropsWithChildren<ConstructionPanelProps>
> = ({ portfolioHomeId }) => (
  <>
    <LatchelCard portfolioHomeId={portfolioHomeId} />
    <SystemWorkOrderHistoryCard portfolioHomeId={portfolioHomeId} />
    <WorkOrderHistoryCard portfolioHomeId={portfolioHomeId} />
    <ConstructionHistoryCard portfolioHomeId={portfolioHomeId} />
  </>
)
